import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { BaseComponent } from 'src/app/core/base-classes/base/base.component';

@Component({
    selector: 'fury-toolbar-search',
    templateUrl: './toolbar-search.component.html',
    styleUrls: ['./toolbar-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToolbarSearchComponent extends BaseComponent implements OnInit {

  public isOpen: boolean;

  @ViewChild('input', { read: ElementRef, static: true }) public input: ElementRef;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  open() {
    this.isOpen = true;

    setTimeout(() => {
      this.input.nativeElement.focus();
    }, 100);

  }

  close() {
    this.isOpen = false;
  }

}
